export default __webpack_public_path__ + "static/media/SOTD_1.44a77985.png";